var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinbaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2632_1388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 225,
    height: 225
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 112.5,
    r: 112.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2632_1388)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "url(#pattern0_2632_1388)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2632_1388",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2632_1388",
    transform: "scale(0.00444444)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2632_1388",
    width: 225,
    height: 225,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbaseIcon);
export default __webpack_public_path__ + "static/media/Coinbase-icon.5bdbb976cc98e9be5ca62ee00c2769f4.svg";
export { ForwardRef as ReactComponent };